import * as React from 'react';
import { IUniformStepProps } from './interfaces';

export function UniformStep(props: IUniformStepProps) {
  const { children } = props;
  return <div>{children}</div>;
}
